<template>
    <div class="text-center align-self-start">
        <h4 class="rounded-header"> 
            {{ name }}
        </h4>
        <div class="chart-wrapper" >
            <div v-show="informationRepresentation === 'radar'">  
                <div class="checkbox-wrapper m-1" v-for="(dataset, index) in chartData.datasets" :key="dataset.label">
                    <input class="checkbox-margin" type="checkbox" aria-label="" :name="dataset.label" checked="" @click="updateRadarChart(index)" :value="index">
                    <label class="m-1"> {{chartData.datasets[index].label}}</label>
                </div>                
                <radar-chart :chart-data="chartData" :description="chartDataDescription" ref="radarChart"></radar-chart>                
            </div>
            <div v-show="informationRepresentation === 'table'">
                <phase-table :dataChart="chartData"></phase-table>
            </div>
            <div v-show="informationRepresentation === 'bar'">
                <div class="checkbox-wrapper m-1" v-for="(dataset, index) in chartData.datasets" :key="dataset.label">
                    <input class="m-2 checkbox-margin" type="checkbox" aria-label="" :name="dataset.label" checked="" @click="updateBarChart(index)" :value="index">
                    <label class="m-1"> {{ chartData.datasets[index].label }}</label>
                </div>
                <bar-chart :chart-data="chartData" ref="barChart"></bar-chart>
            </div>

            <div class="btn-group mt-2 " role="group">
                <button
                    type="button"
                    class="btn btn-secondary"
                    :class="{ active: informationRepresentation === 'radar' }"
                    @click="informationRepresentation = 'radar'"
                >
                    Netzdiagramm
                </button>
                <button
                    type="button"
                    class="btn btn-secondary"
                    :class="{ active: informationRepresentation === 'table' }"
                    @click="informationRepresentation = 'table'"
                >
                    Tabelle
                </button>
                <button
                    type="button"
                    class="btn btn-secondary"
                    :class="{ active: informationRepresentation === 'bar' }"
                    @click="informationRepresentation = 'bar'"
                >
                    Säulendiagramm
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import RadarChart from "./RadarChart.vue";
import BarChart from "./BarChart.vue";
import PhaseTable from "./PhaseTable.vue";

    export default {
    name: "InformationVisualisation",
    props: ["id","name"],
    components: {
        RadarChart,
        BarChart,
        PhaseTable
    },
    data: function() {
        return {
            chartData: null,
            chartDataDescription: [],
            informationRepresentation: "radar",            
            dataArr: [],
            activeId: -1,
            phaseCount: 0,                 
        }
    },
    created() {
        this.fetchChartData();
    },
    mounted(){
        console.log("mounted InformationVisualisation");
    },
    updated(){
        console.log("updated InformationVisualisation");
        this.loadChartData();      
    },
    methods:{
        fetchChartData() { 
            //console.log("Current Route Name:");
            //console.log(this.$route.params.routeName);
            //IDEE DENNIS - BEDINGUNG, nur Daten holen, wenn das Array noch leer ist

            let vm = this;
            const phaseLabels = [];
            const avgUserScores = [];
            const avgScores = [];
            const maxScores = [];

            let rawOverviewData = [];
            let rawPhaseData = [];
            let rawIndividualPhaseData = [];
            let phaseData = [];
            let tempPhaseData = [];
            let rawData = [];

            const defaultChartSetting_Individual = {
                label: "Individueller Wert",
                hidden: false,
                backgroundColor: "rgba(242, 148, 0, 0.3)",
                borderColor: "rgba(242, 148, 0, 0.9)",
                pointBackgroundColor: "rgba(242, 148, 0, 0.9)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgb(255, 99, 132)",
                data: [],
                fill: true
            };
            const defautlChartSetting_Average = {
                label: "Mittelwert", hidden: false,
                backgroundColor: "rgba(23, 156, 125, 0.1)",
                borderColor: "rgba(23, 156, 125, 0.5)",
                pointBackgroundColor: "rgba(23, 156, 125, 0.5)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgb(54, 162, 235)",
                data: [],
                fill: true
            };
            const defaultChartSetting_Max = {
                label: "Max-Wert", hidden: false,
                backgroundColor: "rgba(45, 182, 245, 0.1)",
                borderColor: "rgba(45, 182, 245, 0.5)",
                pointBackgroundColor: "rgba(45, 182, 245, 0.5)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgb(54, 162, 235)",
                data: [],
                fill: true
            };

            axios
                .all([axios.get("/api/scoresByPhase"), 
                    axios.get("/api/scoresPerQuestionByPhase"),
                    axios.get("/api/scoresByPhaseByUser"),
                    axios.get("/api/scoresPerQuestionByPhaseByUser")])                    
                .then(axios.spread((...responses) => {
                    //fetch raw overview data
                    rawOverviewData = responses[0].data;
                    
                    //fetch average user scores for chart overview
                    responses[2].data.forEach(element => {
                        avgUserScores.push(element.AvgScore); //still needs to be edited to contain leading zero (0.7 vs .7) -> MM                                
                    });
                    defaultChartSetting_Individual.data = avgUserScores;

                    //fetch phaseNames for chart overiew labels
                    rawOverviewData.forEach(element => {
                        phaseLabels.push(element.PhaseName);                
                    });

                    //fetch avgScores for chart overview
                    rawOverviewData.forEach(element => {
                        avgScores.push(element.AvgScore);                
                    });                    
                    defautlChartSetting_Average.data = avgScores;                    

                    //fetch maxScores for chart overview
                    rawOverviewData.forEach(element => {
                        maxScores.push(element.MaxScore);                
                    });                    
                    defaultChartSetting_Max.data = maxScores;

                    //set chart data overview
                    const overviewDataChart = {
                        labels: phaseLabels,
                        datasets: [
                            defaultChartSetting_Individual,
                            defautlChartSetting_Average,
                            defaultChartSetting_Max
                        ]
                    }
                    const dataArrEntryOverview = {
                        key: 0,
                        dataChart: overviewDataChart
                    }
                    this.dataArr.push(dataArrEntryOverview);

                    //fetch raw phase data
                    rawPhaseData = responses[1].data;
                    //console.log("rawPhaseData:");
                    //console.log(rawPhaseData);

                    //fetch raw individual phase data
                    rawIndividualPhaseData = responses[3].data;
                    //console.log("rawIndividualPhaseData:");
                    //console.log(rawIndividualPhaseData);
                    
                    rawPhaseData.forEach(element => {
                        if(parseInt(element.PhaseId) > this.phaseCount) {
                            this.phaseCount = parseInt(element.PhaseId);
                        }
                    });
                    
                    //process raw phase data for phase specific questions
                    let i = 0;
                    rawPhaseData.forEach(element => {                    
                        if(element.IsFrameworkCondition == false) {

                            const localDefaultChartSetting_Individual = {
                            label: "Individueller Wert",
                            hidden: false,
                            backgroundColor: "rgba(242, 148, 0, 0.3)",
                            borderColor: "rgba(242, 148, 0, 0.9)",
                            pointBackgroundColor: "rgba(242, 148, 0, 0.9)",
                            pointBorderColor: "#fff",
                            pointHoverBackgroundColor: "#fff",
                            pointHoverBorderColor: "rgb(255, 99, 132)",
                            data: [],
                            fill: true
                            };
                            const localDefautlChartSetting_Average = {
                                label: "Mittelwert", hidden: false,
                                backgroundColor: "rgba(23, 156, 125, 0.1)",
                                borderColor: "rgba(23, 156, 125, 0.5)",
                                pointBackgroundColor: "rgba(23, 156, 125, 0.5)",
                                pointBorderColor: "#fff",
                                pointHoverBackgroundColor: "#fff",
                                pointHoverBorderColor: "rgb(54, 162, 235)",
                                data: [],
                                fill: true
                            };
                            const localDefaultChartSetting_Max = {
                                label: "Max-Wert", hidden: false,
                                backgroundColor: "rgba(45, 182, 245, 0.1)",
                                borderColor: "rgba(45, 182, 245, 0.5)",
                                pointBackgroundColor: "rgba(45, 182, 245, 0.5)",
                                pointBorderColor: "#fff",
                                pointHoverBackgroundColor: "#fff",
                                pointHoverBorderColor: "rgb(54, 162, 235)",
                                data: [],
                                fill: true
                            };

                            if(phaseData[element.PhaseId] == null) {
                                //hier gehe ich genau einmal pro phase mit phasenspezifischen fragen rein, nachdem dann ein eintrag gesetzt wurde
                                
                                //set chart data current phase
                                let currentPhaseDataChart = {
                                    labels: [], //needs to be filled after the foreach loop - MM - 2022-06-09
                                    description: [],
                                    tempIndividualScores: [],
                                    tempAvgScores: [],
                                    tempMaxScores: [],
                                    datasets: [
                                        {...localDefaultChartSetting_Individual}, //copy the chart setting without data and without holding the reference using the js spread syntax- MM - 2022-06-09
                                        {...localDefautlChartSetting_Average},
                                        {...localDefaultChartSetting_Max}         
                                    ]
                                }
                                let dataArrEntryCurrentPhase = {
                                    key: element.PhaseId,
                                    dataChart: currentPhaseDataChart
                                }                                
                                let tempArrEntryCurrentPhase = {
                                    key: element.PhaseId,
                                    avgScore: [],
                                    maxScore: []
                                }
                                
                                phaseData[element.PhaseId] = dataArrEntryCurrentPhase;
                            }
                            //fill data and labels for phaseData for phase specific questions
                            //phaseData[element.PhaseId].dataChart.labels.push(element.QuestionName + "&&" + element.QuestionKeyword);
                            phaseData[element.PhaseId].dataChart.labels.push(element.QuestionName);
                            phaseData[element.PhaseId].dataChart.description.push(element.QuestionKeyword);
                            //phaseData[element.PhaseId].dataChart.tempIndividualScores.push(rawIndividualPhaseData[i].Score);
                            if (i <= rawIndividualPhaseData.length - 1) {
                                if (rawIndividualPhaseData[i].PhaseId == element.PhaseId && rawIndividualPhaseData[i].QuestionId == element.QuestionId) {
                                    phaseData[element.PhaseId].dataChart.tempIndividualScores.push(rawIndividualPhaseData[i].Score);
                                }
                            }
                            phaseData[element.PhaseId].dataChart.tempAvgScores.push(element.AvgScore);                            
                            phaseData[element.PhaseId].dataChart.tempMaxScores.push(element.MaxScore);
                        }
                        else if(element.IsFrameworkCondition == true) {
                            //Funktioniert so erstmal
                            const localDefaultChartSetting_Individual = {
                            label: "Individueller Wert",
                            hidden: false,
                            backgroundColor: "rgba(242, 148, 0, 0.3)",
                            borderColor: "rgba(242, 148, 0, 0.9)",
                            pointBackgroundColor: "rgba(242, 148, 0, 0.9)",
                            pointBorderColor: "#fff",
                            pointHoverBackgroundColor: "#fff",
                            pointHoverBorderColor: "rgb(255, 99, 132)",
                            data: [],
                            fill: true
                            };
                            const localDefautlChartSetting_Average = {
                                label: "Mittelwert", hidden: false,
                                backgroundColor: "rgba(23, 156, 125, 0.1)",
                                borderColor: "rgba(23, 156, 125, 0.5)",
                                pointBackgroundColor: "rgba(23, 156, 125, 0.5)",
                                pointBorderColor: "#fff",
                                pointHoverBackgroundColor: "#fff",
                                pointHoverBorderColor: "rgb(54, 162, 235)",
                                data: [],
                                fill: true
                            };
                            const localDefaultChartSetting_Max = {
                                label: "Max-Wert", hidden: false,
                                backgroundColor: "rgba(45, 182, 245, 0.1)",
                                borderColor: "rgba(45, 182, 245, 0.5)",
                                pointBackgroundColor: "rgba(45, 182, 245, 0.5)",
                                pointBorderColor: "#fff",
                                pointHoverBackgroundColor: "#fff",
                                pointHoverBorderColor: "rgb(54, 162, 235)",
                                data: [],
                                fill: true
                            };
                            //Data for Framework Condititions lies behind phase specific data in phaseData
                            if(phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()] == null) {
                                //hier gehe ich genau einmal pro phase mit rahmenbedingungen rein, nachdem ein eintrag gesetzt wurde

                                //set chart data current phase
                                let currentPhaseDataChart = {
                                    labels: [], //needs to be filled after the foreach loop - MM - 2022-06-09
                                    description: [],
                                    tempIndividualScores: [],
                                    tempAvgScores: [],
                                    tempMaxScores: [],
                                    datasets: [
                                        {...localDefaultChartSetting_Individual}, //copy the chart setting without data and without holding the reference using the js spread syntax- MM - 2022-06-09
                                        {...localDefautlChartSetting_Average},
                                        {...localDefaultChartSetting_Max}         
                                    ]
                                }
                                let dataArrEntryCurrentPhase = {
                                    key: (parseInt(element.PhaseId) + this.phaseCount).toString(),
                                    dataChart: currentPhaseDataChart
                                }                                
                                
                                phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()] = dataArrEntryCurrentPhase;
                                //Increase phaseCount like this instead of setting it to phaseID like before
                            }
                            //fill data and labels for phaseData for framework condition questions
                            phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()].dataChart.labels.push(element.QuestionName);
                            phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()].dataChart.description.push(element.QuestionKeyword);
                            //phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()].dataChart.tempIndividualScores.push(rawIndividualPhaseData[i].Score);
                            if (i <= rawIndividualPhaseData.length - 1) {
                                if (rawIndividualPhaseData[i].PhaseId == element.PhaseId && rawIndividualPhaseData[i].QuestionId == element.QuestionId) {
                                    phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()].dataChart.tempIndividualScores.push(rawIndividualPhaseData[i].Score);
                                }
                            }
                            phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()].dataChart.tempAvgScores.push(element.AvgScore);                            
                            phaseData[(parseInt(element.PhaseId) + this.phaseCount).toString()].dataChart.tempMaxScores.push(element.MaxScore);
                        }
                        i = i + 1;                       
                    });
                    //process raw phase data for framework conditions
                    /*rawPhaseData.forEach(element => {
                                                
                    });*/
                    //set chart data phases
                    phaseData.forEach(element => {
                        //inserted logic for chart handling fix -> MM - 2022-07-14
                        const dafuq = JSON.parse(JSON.stringify(element.dataChart.description));
                        const tmpIndividualScores = JSON.parse(JSON.stringify(element.dataChart.tempIndividualScores));
                        const tmpAvgScores = JSON.parse(JSON.stringify(element.dataChart.tempAvgScores));
                        const tmpMaxScores = JSON.parse(JSON.stringify(element.dataChart.tempMaxScores));
                        element.dataChart.description = [...dafuq];
                        element.dataChart.datasets[0].data = [...tmpIndividualScores];
                        element.dataChart.datasets[1].data = [...tmpAvgScores];
                        element.dataChart.datasets[2].data = [...tmpMaxScores];

                        this.dataArr.push(element);
                    });
                    //console.log("phaseData:");
                    //console.log(phaseData);
                    //load data to user interface
                    if(this.chartData == null)
                        this.loadChartData();
                }))
                .catch(err => console.log(err));                                    
        },
        loadChartData() {
            console.log("chart data loaded");
            //console.log("dataArr:");
            //.log(this.dataArr);
            //console.log("this.activeId: " + this.activeId);
            let fakeId = this.id; //Create copy of id for checking, can be changed if were in framework phase
            if (this.id != 0){ //Does not work in overview so this protects it
                (this.$route.params.routeName.indexOf('framework') > -1) ? fakeId = (this.id + this.phaseCount): fakeId = this.id;
            }
            if (fakeId != this.activeId) {
                this.dataArr.forEach(element => {
                    if(element.key == fakeId) {
                        //console.log("switched active id to: " + fakeId);
                        this.activeId = fakeId;

                        //inserted logic for chart handling fix -> MM, KW - 2022-07-18
                        const tmpDataChart = JSON.parse(JSON.stringify(element.dataChart));
                        this.chartData = {...tmpDataChart};
                        const tmpChartDataDescription = JSON.parse(JSON.stringify(element.dataChart.description));
                        this.chartDataDescription = [...tmpChartDataDescription];                   
                        console.log('ChartData:');
                        console.log(this.chartData);
                    }
                });
                //console.log(this.chartData);
            }                        
        },
        updateRadarChart(dataIndex){
            this.$refs.radarChart.updateChart(dataIndex);
        },
        updateBarChart(dataIndex){
            this.$refs.barChart.updateChart(dataIndex);
        },        
    },
};
</script>